import DefaultImg from "../../../../assets/img/default-image.svg";
import useFileNameLength from "../../../../hooks/useFileNameLength";
import { WORKING_RIGHTS_OPTIONS } from "../../../../models/Onboarding/onboarding-values";
import { useAppSelector as useSelector } from "../../../../store";
import { formatFileName } from "../../../../utils/stringUtils";
import CustomButton from "../../../UI/Buttons/CustomButton";
import Download from "../../../UI/Icons/Download";

const PersonalDetails: React.FC = () => {
  const { maxLength, preserveEndChars } = useFileNameLength();
  const userpersonaldetails = useSelector(
    (state) => state.onboarding.userpersonaldetails
  );
  const personaldetails = useSelector(
    (state) => state.onboarding.personaldetails
  );

  // Function to handle resume file download (PDF, DOC, JPEG, PNG)
  const handleDownloadFile = (resume: string, resume_name: string) => {
    const link = document.createElement("a");
    link.href = resume;
    link.target = "_blank"; // Open in a new tab
    link.setAttribute("download", resume_name); // Set desired filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Clean up: remove the link after download
  };

  return (
    <>
      <div className="d-flex">
        <div className="position-relative border border-grey-light rounded-circle p-7px">
          <img
            src={
              userpersonaldetails && userpersonaldetails?.photo?.length > 0
                ? userpersonaldetails?.photo
                : DefaultImg
            }
            alt="candidate"
            className="w-144px h-144px object-fit-cover rounded-circle d-flex"
          />
        </div>
      </div>
      <div className="d-flex flex-column gap-10">
        <div className="d-flex gap-50 flex-wrap">
          <div className="d-flex flex-column gap-5">
            <div className="fs-13 fw-400 text-grey-medium">First Name</div>
            <div className="fs-16 fw-400 text-black">
              {userpersonaldetails?.first_name}
            </div>
          </div>
          <div className="d-flex flex-column gap-5">
            <div className="fs-13 fw-400 text-grey-medium">Last Name</div>
            <div className="fs-16 fw-400 text-black">
              {userpersonaldetails?.last_name}
            </div>
          </div>
        </div>
        <div className="d-flex flex-column gap-5">
          <div className="fs-13 fw-400 text-grey-medium">Mobile Number</div>
          <div className="fs-16 fw-400 text-black">
            {userpersonaldetails?.phone_number}
          </div>
        </div>
        <div className="d-flex flex-column gap-5">
          <div className="fs-13 fw-400 text-grey-medium">
            Email (Same as your login, and editable in Account Settings)
          </div>
          <div className="fs-16 fw-400 text-black">
            {userpersonaldetails?.email}
          </div>
        </div>
        <div className="d-flex flex-column gap-5">
          <div className="fs-13 fw-400 text-grey-medium">Home Address</div>
          <div className="fs-16 fw-400 text-black">
            {userpersonaldetails?.address}
          </div>
        </div>
      </div>
      <div className="d-flex flex-column gap-5">
        <div className="fs-13 fw-400 text-grey-medium">Resume:</div>
        <div className="d-flex">
          <CustomButton
            variant={"primary"}
            type="button"
            className="btn-theme bg-off-white text-black"
            onClick={() =>
              handleDownloadFile(
                personaldetails?.resume || "",
                personaldetails?.resume_name || ""
              )
            } // dynamically pass URL and file name
          >
            <Download />
            {formatFileName(personaldetails?.resume_name || "", maxLength, preserveEndChars)}
          </CustomButton>
        </div>
      </div>
      <div className="d-flex flex-column gap-5">
        <div className="fs-13 fw-400 text-grey-medium">
          Are you interested in permanent opportunities as well as casual shifts?
        </div>
        <div className="fs-16 fw-400 text-black">
          {personaldetails?.permanent_employment
            ? "Yes"
            : "No"}
        </div>
      </div>
      <div className="d-flex flex-column gap-5">
        <div className="fs-13 fw-400 text-grey-medium">
          Do you have current working rights in Australia?
        </div>
        <div className="fs-16 fw-400 text-black">
          {personaldetails?.working_rights
            ? WORKING_RIGHTS_OPTIONS[
                personaldetails?.working_rights as keyof typeof WORKING_RIGHTS_OPTIONS
              ]
            : "Not Provided"}
        </div>
      </div>
    </>
  );
};

export default PersonalDetails;
